import { render } from "./FailedView.vue?vue&type=template&id=31f41864&scoped=true"
import script from "./FailedView.vue?vue&type=script&lang=js"
export * from "./FailedView.vue?vue&type=script&lang=js"

import "./FailedView.vue?vue&type=style&index=0&id=31f41864&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f41864"]])

export default __exports__